
    import '/opt/buildhome/repo/components/use-x-chat/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["components-use-x-chat-demo-basic","components-use-x-chat-demo-stream","components-use-x-chat-demo-suggestions","components-use-x-chat-demo-model"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/use-x-chat/index.en-US.md?type=demo')
};